import { render } from "./GamePage.vue?vue&type=template&id=e1929f02"
import script from "./GamePage.vue?vue&type=script&lang=js"
export * from "./GamePage.vue?vue&type=script&lang=js"

import "./GamePage.vue?vue&type=style&index=0&id=e1929f02&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__